import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createContext, useContext, useState } from 'react';
import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { getDefaultValues } from '../components/Controls/utils';
import { DEFAULT_CATEGORY, DEFAULT_PRICE, PLATFORM } from '../constants';
import { PRICE_PERIOD } from '../types';
import { CALCULATOR_TYPE } from '../types/CalculatorType';
import { jsx as _jsx } from "react/jsx-runtime";
var noop = function noop() {};
export var CalculatorContext = /*#__PURE__*/createContext({
  selectedCategory: DEFAULT_CATEGORY,
  setSelectedCategory: noop,
  selectedPlatform: PLATFORM.Evolution,
  setSelectedPlatform: noop,
  catalogOpen: false,
  setCatalogOpen: noop,
  pricePeriod: PRICE_PERIOD.Month,
  setPricePeriod: noop,
  selectedProduct: null,
  setSelectedProduct: noop,
  calculatorType: CALCULATOR_TYPE.Main,
  layoutType: LAYOUT_TYPE.Desktop,
  config: {},
  fetcherFn: function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", undefined);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetcherFn() {
      return _ref.apply(this, arguments);
    };
  }(),
  products: {},
  setProducts: noop,
  actions: {}
});
export var useCalculatorContext = function useCalculatorContext() {
  return useContext(CalculatorContext);
};
export function CalculatorContextProvider(_ref2) {
  var _ref2$layoutType = _ref2.layoutType,
    layoutType = _ref2$layoutType === void 0 ? LAYOUT_TYPE.Desktop : _ref2$layoutType,
    _ref2$calculatorType = _ref2.calculatorType,
    calculatorType = _ref2$calculatorType === void 0 ? CALCULATOR_TYPE.Main : _ref2$calculatorType,
    fetcherFn = _ref2.fetcherFn,
    config = _ref2.config,
    iniState = _ref2.iniState,
    initialActiveProduct = _ref2.initialActiveProduct,
    actions = _ref2.actions,
    children = _ref2.children;
  var _useState = useState(function () {
      if (initialActiveProduct) {
        var _config$products;
        return (_config$products = config.products) === null || _config$products === void 0 ? void 0 : _config$products[initialActiveProduct].platform;
      }
      return config.platforms[0].id;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPlatform = _useState2[0],
    setSelectedPlatform = _useState2[1];
  var _useState3 = useState(config.catalog[selectedPlatform][0].id),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedCategory = _useState4[0],
    setSelectedCategory = _useState4[1];
  var _useState5 = useState(function () {
      if (iniState && Object.keys(iniState).length > 0) {
        return {
          id: Object.keys(iniState)[0],
          idx: 0
        };
      }
      if (initialActiveProduct) {
        return {
          id: initialActiveProduct,
          idx: 0
        };
      }
      return null;
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedProduct = _useState6[0],
    setSelectedProduct = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    open = _useState8[0],
    setOpen = _useState8[1];
  var _useState9 = useState(PRICE_PERIOD.Month),
    _useState10 = _slicedToArray(_useState9, 2),
    pricePeriod = _useState10[0],
    setPricePeriod = _useState10[1];
  var _useState11 = useState(function () {
      if (iniState && Object.keys(iniState).length > 0) {
        return iniState;
      }
      if (initialActiveProduct) {
        var _config$products$init;
        var controls = (_config$products$init = config.products[initialActiveProduct].formConfig) === null || _config$products$init === void 0 ? void 0 : _config$products$init.controls;
        if (controls) {
          return _defineProperty({}, initialActiveProduct, [{
            data: _objectSpread(_objectSpread({}, getDefaultValues(controls !== null && controls !== void 0 ? controls : {})), {}, {
              productQuantity: 1
            }),
            price: DEFAULT_PRICE
          }]);
        }
      }
      return {};
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    products = _useState12[0],
    setProducts = _useState12[1];
  return /*#__PURE__*/_jsx(CalculatorContext.Provider, {
    value: {
      selectedCategory: selectedCategory,
      setSelectedCategory: setSelectedCategory,
      selectedPlatform: selectedPlatform,
      setSelectedPlatform: setSelectedPlatform,
      pricePeriod: pricePeriod,
      setPricePeriod: setPricePeriod,
      selectedProduct: selectedProduct,
      setSelectedProduct: setSelectedProduct,
      catalogOpen: open,
      setCatalogOpen: setOpen,
      layoutType: layoutType,
      calculatorType: calculatorType,
      config: config,
      fetcherFn: fetcherFn,
      products: products,
      setProducts: setProducts,
      actions: actions
    },
    children: children
  });
}